import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { AddGradedUnits } from 'app/library/graded-unit/actions';
import { IGradedUnitQuery } from 'app/library/graded-unit/interfaces/graded-unit.query.interface';
import { GradedUnit } from 'app/library/graded-unit/models/graded-unit.model';
import { IPartialGradeQuery } from 'app/library/partial-grade/interfaces/partial-grade.query.interface';
import { PartialGrade } from 'app/library/partial-grade/models/partial-grade.model';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class ParticipantPartialGradesService {
    constructor(private http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) private environment: IEnvironment, private _store: Store) {}

    getAll(moduleId: string): Observable<PartialGrade[]> {
        return this.http.get<IPartialGradeQuery[]>(`${this.environment.apiUrl}/modules/${moduleId}/partial-grades/participant`).pipe(
            tap((queries) => {
                const gradedUnitsConatiner: { [key: string]: GradedUnit } = {};

                queries.forEach((query) => {
                    if (!gradedUnitsConatiner[query.graded_unit.id]) {
                        const gradedUnitQuery = query.graded_unit as IGradedUnitQuery;

                        gradedUnitsConatiner[query.graded_unit.id] = new GradedUnit(gradedUnitQuery);
                    }
                });

                const gradedUnits = Object.keys(gradedUnitsConatiner).map((gradedUnitId) => gradedUnitsConatiner[gradedUnitId]);

                this._store.dispatch(new AddGradedUnits(gradedUnits));
            }),
            map((queries) => queries.map((query) => new PartialGrade(query)))
        );
    }
}
